export const getProfile ={
    "success": true,
    "message": "เรียกข้อมูลสำเร็จ",
    "result": {
        "profile": {
            "loginId": 24,
            "email": "nirav@gmail.com",
            "role": "1",
            "name": "Nirav",
            "surname": "Joshi",
            "position": "Manager",
            "picture": "https://files.takeket.co/uploads/avatar3.webp",
        }
    }
}